<script setup lang="ts">
import { ElNotification } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import { useGoatStore } from '@/stores/goat'
import { ModeEnum } from '@/types/enums'

const { t } = useI18n()
const { updateMode } = siteUtils
const loading = ref(false)
const auth = useAuthStore()
function handleAcceptTermsResponse(status: string, token: string, email: string, data: FormTypes.SubmitForm) {
  switch (status) {
    case 'ok':
    { const goat = useGoatStore()
      const { gaLogin, gaLoginMethods, gaSections, gaSignUp, contextGaRef } = gaUtils
      const contextParams = {
        method: `${gaLoginMethods.goat}${goat.getGoatDetails?.serviceName?.length ? ',' : ''}${goat.getGoatDetails?.serviceName}`,
        gs_section: contextGaRef.value?.gs_section || gaSections.loginForm
      }
      goat.updateGoatDetails({})
      auth.login(token, email)
      gaSignUp({ ...contextParams, gs_context: `${data?.form?.acceptCommunication ? 'acceptCommunication=true' : 'acceptCommunication=false'}` })
      gaLogin(contextParams)
      break }
    default:
      updateMode(ModeEnum.login)
      ElNotification({
        title: t('acceptTerms.notify.unavailable.title'),
        message: t('acceptTerms.notify.unavailable.message'),
        type: 'error',
        duration: 9000,
        offset: 100,
        appendTo: '#auth-wrapper',
        customClass: 'right-1/2 translate-x-1/2 large absolute'
      })
  }
}
function onSubmit(data: FormTypes.SubmitForm) {
  const { getGoatApiUrl } = siteUtils
  const { getAxiosInstance, catchError } = appUtilsPlugin
  const goat = useGoatStore()
  loading.value = true
  ElNotification.closeAll()
  getAxiosInstance()
    ?.post(getGoatApiUrl(`${goat.getGoatDetails?.serviceName}-login`), { ...data.form, token: goat.getGoatDetails?.serviceToken })
    .then((response) => {
      handleAcceptTermsResponse(response?.data?.status || '', response?.data?.token ?? '', response?.data?.email ?? '', data)
    })
    .catch((err) => {
      updateMode(ModeEnum.login)
      catchError({ appendTo: '#auth-wrapper' })(err)
    })
    .then(() => {
      loading.value = false
    })
}
</script>

<template>
  <div
    class="box-form-wrapper mx-auto max-w-2xl big:max-w-(--breakpoint-xl) big:px-16 mt-5"
  >
    <div
      class="box-form big:mt-10 mx-3 bg-white pt-10 big:pt-16 pb-10 big:pb-16 px-2 big:px-16 rounded-2xl flex flex-col items-center"
    >
      <div class="mx-auto w-full max-w-md">
        <h1 class="text-lg big:text-2xl uppercase font-semibold text-center tracking-wider ">
          {{ t('acceptTerms.title') }}
        </h1>
        <goat-form-component
          class="mt-6 big:mb-5 w-full"
          size="large"
          hide-required-asterisk
          @submit="onSubmit"
        >
          <template #default="{ submit }">
            <goat-site-accept-terms-check-boxes />
            <goat-form-fields-group
              justify="space-between"
            >
              <el-button
                type="info"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                @click="updateMode(ModeEnum.login)"
              >
                {{ t('acceptTerms.cancelBtn') }}
              </el-button>
              <el-button
                type="primary"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                size="large"
                :loading="loading"
                @click="submit()"
              >
                {{ t('acceptTerms.confirmBtn') }}
              </el-button>
            </goat-form-fields-group>
          </template>
        </goat-form-component>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
</style>
